<h1 class="main sticky-top">
  <div class="row">
      <div class="col-sm-4">Token Management</div>
      <div class="col-sm-8 text-md-end">
          <form class="d-flex flex-row align-items-center flex-wrap justify-content-end">
              <button type="button" (click)="onCancelClicked()"
                  class="btn btn-info mt-2 mb-2 me-sm-2 mb-sm-0">Close</button>
              <button
                  *accessControl="[ApplicationRoles.EDLADMIN]"
                  [ladda]="busy" [disabled]="!this.canUpdate()" type="button" (click)="onSubmit()"
                  class="btn btn-primary mt-2 mb-2 me-sm-2 mb-sm-0">Save</button>

          </form>
      </div>
  </div>
</h1>

<div class="content portal-settings">
  <form [formGroup]="form" errorTailor>
      <div class="row">
          <div class="form-group col-sm-6">
              <label for="tokenValue" class="form-label">Token:</label>
              <input type="text" id="tokenValue" class="form-control" formControlName="Token" placeholder="Token will be auto-generated on save." />
          </div>
          <div class="form-group col-sm-6">
              <label for="tokenDescription" class="form-label">Description</label>
              <input type="text" id="tokenDescription" class="form-control" formControlName="Description"
                  placeholder="Enter token description here." />
          </div>
      </div>

      <div class="row mb-4">
        <div class="form-group col-sm-6">
            <label for="tokenContext" class="form-label">Application Context:</label>
            <select id="tokenContext" class="form-select" formControlName="Context">
                <option value="0">All Applications</option>
                <option value="1">Comply</option>
                <option value="3">PAETEP</option>
            </select>
        </div>
      </div>

      <div class="row mb-4 ">
        <div class="form-group  col-sm-12">
            <fieldset>
                <legend>Display on self-registration:</legend>
                <div class="row d-flex flex-row">
                  <div class="form-group col-sm-5" >
                    <label class="form-control form-check-label" for="ShowIsNT"><input class="form-check-input" type="checkbox" id="ShowIsNT"
                        formControlName="ShowIsNT" /> Nontenured employee </label>
                  </div>
                  <div class="form-group  col-sm-5" >
                    <label class="form-control form-check-label" for="ShowUserType"><input class="form-check-input" type="checkbox" id="ShowUserType"
                        formControlName="ShowUserType" /> User Type </label>
                  </div>
                  <div class="form-group  col-sm-5" >
                    <label class="form-control form-check-label" for="ShowPAETEPBuildings"><input class="form-check-input" type="checkbox" id="ShowPAETEPBuildings"
                        formControlName="ShowPAETEPBuildings" /> PAETEP Buildings </label>
                  </div>
                  <div class="form-group  col-sm-5" >
                    <label class="form-control form-check-label" for="ShowVolAreas"><input class="form-check-input" type="checkbox" id="ShowVolAreas"
                        formControlName="ShowVolAreas" /> Comply Volunteer Areas </label>
                  </div>
                  <div class="form-group  col-sm-5" >
                    <label class="form-control form-check-label" for="ShowPPID"><input class="form-check-input" type="checkbox" id="ShowPPID"
                        formControlName="ShowPPID" /> PPID </label>
                  </div>
              </div>
            </fieldset>
        </div>
      </div>


      <div class="row mb-4">
          <h5 class="col-sm-4">Associated Roles</h5>
          <div *ngIf="form.enabled"  class="col-sm-8 text-md-end pb-2">
              <button type="button" (click)="addRoleClicked()" class="btn btn-secondary">Add Role(s)</button>
          </div>

        <hr />

        <edl-entries-form [formGroup]="form.get('Roles')"></edl-entries-form>
      </div>

      <div class="row mb-2">
          <h5 class="col-sm-4">Associated Groups</h5>
          <div *ngIf="form.enabled" class="col-sm-8 text-md-end pb-2">
              <button type="button" (click)="addGroupClicked()" class="btn btn-secondary">Manage Groups</button>
          </div>

          <hr />
        <edl-entries-form [formGroup]="form.get('Groups')"></edl-entries-form>
      </div>

  </form>
</div>